import { render } from "./LayoutAuthorization.vue?vue&type=template&id=76d5255d&ts=true"
import script from "./LayoutAuthorization.vue?vue&type=script&lang=ts"
export * from "./LayoutAuthorization.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__